export const REACT_APP_VERIFY_USER = 'user/verify-user';
